<template>
  <div class="product-card__prices--internet" data-eq-part="product-card__prices">
    <div>
      {{ product.getRecurringPriceWithSavingsFormatted('base_price', 2, true) }}&thinsp;€&thinsp;/&thinsp;Monat
    </div>
    <div v-if="followUpPriceString" v-html="followUpPriceString" />
  </div>
</template>

<script setup lang="ts">
import Product from '@/classes/Product';
import { formatNumber } from '@/helpers';
import { computed } from 'vue';

const props = defineProps<{
  product: Product
}>();

const followUpPriceString = computed<string | undefined>(() => {
  const savings = props.product.getPriceSavings();

  if (savings.length === 0) return undefined;

  const savingStrings: string[] = [];

  savings.forEach((saving, inx) => {
    let savingPrice: string | number = props.product.getRecurringPriceValue('base_price', true) - saving.value;
    if (savingPrice < 0) savingPrice = 0;
    savingPrice = `${formatNumber(savingPrice, 2)}&thinsp;€&thinsp;/&thinsp;Monat`;

    if (inx === 0) {
      savingStrings.push(`für ${saving.toMonth > 1 ? `${saving.toMonth} Monate` : 'einen Monat'}`);
    } else {
      const savingDuration = (saving.toMonth - (saving.fromMonth - 1)) || 1;
      savingStrings.push(`danach für ${savingDuration > 1 ? `weitere ${savingDuration} Monate` : 'einen weiteren Monat'} ${savingPrice}`);
    }
  });

  savingStrings.push(`danach ${props.product.getRecurringPriceValueFormatted('base_price', 2, true)}&thinsp;€&thinsp;/&thinsp;Monat`);

  return savingStrings.join(', ');
});
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.product-card__prices--internet {
  --prices-grid-gap: 20px;
  padding: 20px 0;
  background-color: #ECF2F6;
  display: grid;
  grid-template-columns: auto;
  align-items: start;
  justify-content: center;
  text-align: center;
  gap: 10px;
  grid-template-rows: auto auto 1fr;

  > div {
    padding: 0 20px;

    @media(min-width: map-get($grid-breakpoints, 'lg')) {
      padding: 0 40px;
    }

    &:first-child {
      grid-row: 1 / 2;
      grid-column: 1 / 2;
      font-size: 1.25rem;
      font-weight: 700;
      line-height: 1.5;

      @media(min-width: map-get($grid-breakpoints, 'lg')) {
        font-size: 1.875rem;
      }
    }

    &:nth-child(2) {
      grid-row: 2 / 3;
      grid-column: 1 / 2;
      font-size: .75rem;

      @media(min-width: map-get($grid-breakpoints, 'lg')) {
        font-size: 1.125rem;
      }
    }
  }
}
</style>
